import http from "./http-common";

class DataService {
  Login(data) {
    return http.get(`admin/login?password=${data.password}&mobile=${data.userToken}`);
  }

  FindAllUsers() {
    return http.get("admin/findAllAdmins");
  }

  FindAdminByVendorId(data) {
    return http.get(
      `admin/findAdminByVendorId?page=${data?.pageNo}&limit=${data?.limit}&vendorId=${data?.vendorId}&schoolId=${data?.schoolId}${data?.class1 ? "&class1=" + data.class1 : ""
      }`
    );
  }

  FindAllUsersByParams(data) {
    return http.get(
      `admin/findAdminByRole?${data?.pageNo
        ? `page=${data.pageNo}&limit=${data.limit}&role=${data.role}`
        : data
      }`
    );
  }

  AddSchoolAdmin(data) {
    return http.patch("admin/addSchoolAdmin", data);
  }

  DeleteSchoolAdmin(data) {
    return http.patch("admin/deleteSchoolAdmin", data);
  }

  FingerprintscanByVendorId(data) {
    return http.get(`admin/findFingerprintscanByVendorId?${data}`);
  }

  GetAdminByAdminId(id) {
    return http.get(`admin/findFingerprintscanByAdminId?${id}`);
  }

  GetReportPDF(query) {
    return http.get(`admin/downloadReports?${query}`, {
      responseType: "blob",
    });
  }

  UpdateFingerprint(id, data) {
    return http.patch(`admin/updateFingerprintscan?userData_id=${id}`, data);
  }

  UpdateStatus(id, data) {
    return http.patch(`admin/updateRegister?admin_id=${id}`, data);
  }

  UpdateUser(id, data) {
    return http.patch(`admin/updateFingerprintscan?userData_id=${id}`, data);
  }

  CreateReportByUserDataId(data) {
    return http.post("admin/createReport", data);
  }

  GetReportByUserDataId(id) {
    return http.get(`admin/findReportByUserDataId?userDataId=${id}`);
  }

  GetUserByUserId(id) {
    return http.get(`admin/findFingerprintscanById?userData_id=${id}`);
  }

  CreateAdmin(data) {
    return http.post("admin/registerUserByAdmin", data, {
      headers: { "Content-Type": "application/json" },
    });
  }

  AddStudentExcel(data) {
    return http.post("admin/excel/students", data);
  }
}

export default new DataService();